<template>
    <v-row
        class="row no-gutters"
    >
        <v-col
            class="pl-3 pa-0"
            cols="10"
            xl="3"
            lg="5"
            md="6"
            sm="8"
        >
            {{ keyConsent | humanReadableField }}
        </v-col>
        <v-col
            class="px-1 py-0"
            cols="auto"
        >
            <v-checkbox
                class="ma-0 pa-0"
                :input-value="valueConsent"
                :true-value="true"
                :false-value="false"
                hide-details=""
                disabled
            />
        </v-col>
    </v-row>
</template>

<script>

import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class BrandConsent extends Vue {
    @Prop() keyConsent;
    @Prop() valueConsent;
}
</script>
